import React, { Dispatch, ReactNode } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { IStore } from '@rbi-ctg/store';
import StoreCard from 'components/store-card';

import CardContainer from './card-container';
import LoadingIndicator from './loading-indicator';
import Cards from './styled/cards';

interface IStoreCardsContainerProps extends IBaseProps {
  isListView?: boolean;
  noStoresElement: ReactNode;
  searching: boolean;
  stores?: IStore[];
  renderStore: (store: IStore, index: number, all: IStore[]) => ReactNode | void;
  activeStoreId?: string;
}

interface IStoreCardsProps extends Omit<IStoreCardsContainerProps, 'renderStore'> {
  activeStoreId?: any;
  setActiveStoreId: Dispatch<any>;
  nearbyStoreCardRefs?: object;
}

function Content({
  isListView,
  noStoresElement,
  renderStore,
  searching,
  stores,
}: IStoreCardsContainerProps) {
  if (searching) {
    return <LoadingIndicator />;
  }
  if (stores?.length === 0) {
    return <>{noStoresElement}</>;
  }
  return <Cards isListView={isListView}>{stores?.map(renderStore)}</Cards>;
}

export function StoreCardsContainer({
  isListView,
  renderStore,
  searching,
  noStoresElement,
  stores,
  activeStoreId,
}: IStoreCardsContainerProps) {
  return (
    <CardContainer isListView={isListView}>
      <Content
        isListView={isListView}
        renderStore={renderStore}
        searching={searching}
        noStoresElement={noStoresElement}
        stores={stores}
        activeStoreId={activeStoreId}
      />
    </CardContainer>
  );
}

export function StoreCards({
  isListView,
  searching,
  stores,
  nearbyStoreCardRefs,
  setActiveStoreId,
  noStoresElement,
  activeStoreId,
}: IStoreCardsProps) {
  return (
    <StoreCardsContainer
      isListView={isListView}
      searching={searching}
      stores={stores}
      noStoresElement={noStoresElement}
      activeStoreId={activeStoreId}
      renderStore={restaurant => {
        return (
          <StoreCard
            ref={nearbyStoreCardRefs?.[restaurant._id]}
            restaurant={restaurant}
            isListView={isListView}
            key={restaurant._id}
            isSelected={activeStoreId === restaurant._id}
            onClick={() => {
              if (restaurant._id === activeStoreId) {
                return;
              }
              setActiveStoreId(restaurant._id);
            }}
          />
        );
      }}
    />
  );
}
